<template>
  <el-select
      v-model="model"
      :multiple="multiple"
      :collapse-tags="collapseTags"
      :placeholder="placeholder"
      :filterable="filterable"
      :allow-create="allowCreate"
      :default-first-option="defaultFirstOption">
    <el-option
        v-for="item in options"
        :key="item[optionValue]"
        :label="item[optionLabel]"
        :value="optionValue ? item[optionValue] : item">
    </el-option>
  </el-select>
</template>

<script>
export default {
  nameClassStyle: 'input-select',
  props: {
    placeholder: String,
    textIndeterminate: {
      type: String,
      default: 'Tout sélectionner',
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    multiple: Boolean,
    filterable: {
      type: Boolean,
      default: false,
    },
    separator: {
      type: String,
      default: '+',
    },
    optionLabel: {
      type: String,
      default: 'label',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    defaultFirstOption: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: null,
  },
  data() {
    const { value } = this;
    return {
      model: value,
    };
  },
  created() {
    if (this.multiple && !Array.isArray(this.model)) {
      this.model = this.model.length ? this.model.split(this.separator) : [];
    }
  },
  methods: {
    change() {
      if (this.multiple) {
        this.model = !Array.isArray(this.value) && this.value.length
          ? this.value.split(this.separator) : this.value;
        this.$emit('change', Array.isArray(this.value) ? this.value.join(this.separator) : this.value);
      } else {
        this.model = this.value;
        this.$emit('change', this.value);
      }
    },
  },
  watch: {
    model() {
      this.$emit('input', this.multiple && Array.isArray(this.value) ? this.model.join(this.separator) : this.model);
    },
    value() {
      this.change();
    },
  },
};
</script>
